<flx-modal
  [dismissible]="true"
  (dismiss)="closeModal()"
  class="flx-ds"
>
  <div
    class="flx-modal-title"
    data-testId="merge-modal-title"
    flxModalHeaderTitle
  >
    {{ modalTitle }}
  </div>
  <div
    class="flx-modal-subtitle"
    flxModalHeaderSubtitle
  >
    Choose the branch to merge into and write a merge message
  </div>

  <div
    [formGroup]="mergeFG"
    [conditionalControlTypes]="['p-select']"
    (submitForm)="mergeBranch()"
    class="flx-modal-body pb-6"
    flxEnterSubmitForm
  >
    <div class="flex flex-col">
      <div class="flex items-center gap-1">
        <flx-label class="flx-ds mandatory">Merge into</flx-label>
        <flx-info-helper>Branches containing WIP versions cannot be a merge target</flx-info-helper>
      </div>
      <p-select
        [autofocus]="!branchNameFC.disabled"
        [options]="branches"
        [formControl]="branchNameFC"
        [filter]="true"
        [resetFilterOnHide]="true"
        [showClear]="true"
        [invalid]="submitted() && branchNameFC.invalid"
        class="flx-prime-select"
        panelStyleClass="flx-prime-select"
        optionLabel="label"
        optionDisabled="disabled"
        dataKey="label"
        filterBy="label"
        placeholder="Select branch"
        filterPlaceholder="Search by branch name"
        emptyMessage="No branches found"
        appendTo="body"
        data-testId="branch-dropdown"
      >
        <ng-template
          #selectedItem
          let-selected
        >
          <flx-branch-name
            [branchName]="selected.value.name"
            [branchOrder]="selected.value.branchOrder"
            class="flex max-w-[190px]"
            [truncate]="true"
          />
        </ng-template>
        <ng-template
          #item
          let-branch
        >
          <flx-branch-name
            [branchName]="branch.value.name"
            [branchOrder]="branch.value.branchOrder"
            class="flex max-w-[190px]"
            [truncate]="true"
          />
        </ng-template>
      </p-select>
      @if (submitted() && branchNameFC.errors?.required) {
        <flx-error class="flx-ds">Branch is required</flx-error>
      }
    </div>

    <flx-input class="flx-ds relative">
      <flx-label class="flx-ds mandatory">Merge Message</flx-label>
      <input
        [maxlength]="maxLength"
        [flxAutofocus]="branchNameFC.disabled"
        class="w-full"
        formControlName="submitMessage"
        data-testId="merge-message-input"
        flxAutofocus
        flxInput
        placeholder="Describe the changes"
        type="text"
      />

      @let hasMessageError = submitted() && !!submitMessageFC.errors;
      @if (hasMessageError) {
        <flx-error>
          @if (submitMessageFC.errors?.required) {
            This field is required
          }
          @if (submitMessageFC.errors?.minlength) {
            Message must be at least 2 characters long.
          }
          @if (submitMessageFC.errors?.maxlength) {
            Message must be at most {{ maxLength }} characters.
          }
        </flx-error>
      }
      <span
        [class.translate-y-full]="!hasMessageError"
        class="absolute right-0 bottom-0 text-xs text-gray-500"
        >{{ submitMessageFC.value?.length || 0 }}/{{ maxLength }}</span
      >
    </flx-input>

    <flx-textarea class="flx-ds resizable relative">
      <flx-label class="flx-ds">Description</flx-label>
      <textarea
        [maxlength]="descriptionMaxLength"
        (keydown.enter)="$event.stopPropagation()"
        formControlName="description"
        placeholder="Optionally add more detail about this merge"
        data-testId="merge-description-input"
        rows="3"
        flxTextarea
      ></textarea>
      @let hasDescriptionError = submitted() && !!descriptionFC.errors?.maxlength;
      @if (hasDescriptionError) {
        <flx-error data-testId="merge-description-maxlength-error"
          >Description must be less than {{ descriptionMaxLength }} characters</flx-error
        >
      }
      <span
        [class.translate-y-full]="!hasDescriptionError"
        class="absolute right-0 bottom-0 text-xs text-gray-500"
        >{{ descriptionFC.value?.length || 0 }}/{{ descriptionMaxLength }}</span
      >
    </flx-textarea>
  </div>

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="closeModal()"
        class="flx-ds secondary"
        flxButton
        type="button"
        variant="ghost"
      >
        Cancel
      </button>
      <button
        (click)="mergeBranch()"
        class="flx-ds primary"
        data-testId="merge-save-button"
        flxButton
        type="button"
      >
        Merge Branch
      </button>
    </div>
  </div>
</flx-modal>
